import type { OutreachCounts, OutreachInboxTab } from '@discovr/types';
import { UnderlineTabNav } from '../../../components/common/UnderlineTabNav';
import { INBOX_TABS, inboxTabCount } from './inboxTabs';

export interface InboxTabBarProps {
  activeTab: OutreachInboxTab;
  counts?: OutreachCounts;
  onTabChange: (tab: OutreachInboxTab) => void;
}

/** Figma's underline inbox tabs, with a count on every tab once counts load. */
export function InboxTabBar({ activeTab, counts, onTabChange }: InboxTabBarProps) {
  const tabs = INBOX_TABS.map((tab) => ({ ...tab, count: inboxTabCount(counts, tab.key) }));
  return (
    <div className="border-b border-border">
      <UnderlineTabNav tabs={tabs} active={activeTab} onChange={onTabChange} size="lg" className="flex-wrap gap-y-1" />
    </div>
  );
}
